import axiosInstance from './AxiosInstance';

export const getPropertyMonthlyTypeStats = async () => {
  const response = await axiosInstance.get('/graph/property-monthly-type-stats');
  return response.data;
};
